/*
 * @Author: halobug.cn@gmail.com
 * @Description:
 * @Date: 2023-08-11 17:54:20
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-08-22 16:44:42
 */
import logo from 'mastodon/../images/logo.svg';

export const WordmarkLogo: React.FC = () => (
  <svg viewBox='0 0 316 50' className='logo logo--wordmark' role='img'>
    <title>Mastodon</title>
    <use xlinkHref='#logo-symbol-wordmark' />
  </svg>
);

export const SymbolLogo: React.FC = () => (
  <img src={logo} alt='Mastodon' className='logo logo--icon' />
);
